import { createFormat } from 'formatted-input';
import {
  dateBeforeToday,
  hasLength,
  hasNumber,
  numberGreaterThan,
  numberGreaterThanOrEqualTo,
  required,
} from 'redux-freeform';

const formatDelimiter = '_';
const dateFormats = [
  '',
  '_',
  '__/',
  '__/_',
  '__/__/',
  '__/__/_',
  '__/__/__',
  '__/__/___',
  '__/__/____',
];
export const dateFormInputFormatter = createFormat(
  dateFormats,
  formatDelimiter,
);

/**
 * Selectors
 * Default selectors should send 'all' to the API
 */

export const getDefaultFormSelectOption = (key) => ({
  text: `All ${key}`,
  value: 'all',
});

// Start Error message helpers
export const dateFilterErrors = (errorText) => ({
  [dateBeforeToday.error]: errorText,
  [hasLength.error]: errorText,
});
export const dateFilterErrorMessage = dateFilterErrors('Invalid date format');

export const amountErrors = (errorText) => ({
  [hasNumber.error]: errorText,
  [numberGreaterThan.error]: errorText,
  [numberGreaterThanOrEqualTo.error]: errorText,
});
export const minAmountErrorsMessage = amountErrors('Min must be at least $0');
export const maxAmountErrorsMessage = amountErrors(
  'Max must be greater than $0',
);

export const requireErrors = (error_text) => ({
  [required.error]: error_text,
});
